// icons/svg.js

import React from "react";

const SVG = {
  mainLogo: (
    <svg
      width="78"
      height="37"
      viewBox="0 0 78 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M54.4691 32.0304V34.9166C54.4691 35.5676 54.2955 36.0884 53.9266 36.4356C53.5577 36.7828 53.0368 36.9564 52.3641 36.9564H50.7148C50.0204 36.9564 49.4996 36.7828 49.1524 36.4356C48.7835 36.0884 48.6099 35.5893 48.6099 34.9166V32.0304C48.6099 31.3793 48.7835 30.8585 49.1524 30.5113C49.5213 30.1641 50.0421 29.9905 50.7148 29.9905H52.3641C53.0585 29.9905 53.5794 30.1641 53.9266 30.5113C54.2955 30.8802 54.4691 31.3793 54.4691 32.0304ZM53.3406 34.9383V32.0521C53.3406 31.7482 53.2538 31.5095 53.0802 31.3359C52.9066 31.1623 52.6679 31.0755 52.3641 31.0755H50.7148C50.411 31.0755 50.1723 31.1623 49.9987 31.3359C49.8251 31.5095 49.7383 31.7482 49.7383 32.0521V34.9383C49.7383 35.2421 49.8251 35.4808 49.9987 35.6544C50.1723 35.828 50.411 35.9148 50.7148 35.9148H52.3641C52.6679 35.9148 52.9066 35.828 53.0802 35.6544C53.2538 35.4591 53.3406 35.2204 53.3406 34.9383Z"
        fill="url(#paint0_linear_619_632)"
      />
      <path
        d="M42.5337 34.7864V36.8045C42.5337 36.913 42.4903 36.9564 42.3818 36.9564H41.7308C41.6223 36.9564 41.5789 36.913 41.5789 36.8045V30.1424C41.5789 30.0339 41.6223 29.9905 41.7308 29.9905H45.3331C46.5266 29.9905 47.1126 30.5764 47.1126 31.7482V33.0503C47.1126 34.2221 46.5266 34.8081 45.3331 34.8081H42.5337V34.7864ZM45.3331 33.8966C45.8973 33.8966 46.1794 33.6145 46.1794 33.0503V31.7482C46.1794 31.184 45.8973 30.9019 45.3331 30.9019H42.512V33.9183H45.3331V33.8966Z"
        fill="url(#paint1_linear_619_632)"
      />
      <path
        d="M60.068 30.012C60.1765 30.012 60.2416 30.0554 60.2633 30.1639L61.6956 35.3938H61.7389L63.1712 30.1639C63.1929 30.0554 63.258 30.012 63.3665 30.012H64.0175C64.1043 30.012 64.1477 30.0554 64.126 30.1639L62.3032 36.826C62.2598 36.9345 62.1947 36.9779 62.1079 36.9779H61.5219C61.4351 36.9779 61.37 36.9345 61.3266 36.826L59.8076 31.3357H59.7642L58.2451 36.826C58.2017 36.9345 58.1366 36.9779 58.0498 36.9779H57.4639C57.3554 36.9779 57.2903 36.9345 57.2686 36.826L55.4457 30.1639C55.4023 30.0554 55.4457 30.012 55.5542 30.012H56.2052C56.3137 30.012 56.3788 30.0554 56.4005 30.1639L57.8328 35.3938H57.8762L59.3085 30.1639C59.3519 30.0554 59.417 30.012 59.5038 30.012H60.068Z"
        fill="url(#paint2_linear_619_632)"
      />
      <path
        d="M70.3758 36.0882C70.4843 36.0882 70.5277 36.1316 70.5277 36.2401V36.826C70.5277 36.9345 70.4843 36.9779 70.3975 36.9779H65.3412C65.2327 36.9779 65.1893 36.9345 65.1893 36.826V30.1639C65.1893 30.0554 65.2327 30.012 65.3412 30.012H70.289C70.3975 30.012 70.4409 30.0554 70.4409 30.1639V30.7498C70.4409 30.8583 70.3975 30.9017 70.3107 30.9017H66.1442V33.0284H69.3993C69.5078 33.0284 69.5512 33.0718 69.5512 33.1803V33.7662C69.5512 33.8747 69.5078 33.9181 69.421 33.9181H66.1442V36.0882H70.3758Z"
        fill="url(#paint3_linear_619_632)"
      />
      <path
        d="M77.2116 36.8262C77.255 36.9347 77.2333 36.9781 77.1031 36.9781H76.4087C76.3435 36.9781 76.2784 36.9564 76.2567 36.9347C76.2133 36.913 76.1916 36.8696 76.1699 36.8262L74.9764 34.6128H72.5459V36.8262C72.5459 36.9347 72.5025 36.9781 72.394 36.9781H71.743C71.6345 36.9781 71.5911 36.9347 71.5911 36.8262V30.1424C71.5911 30.0339 71.6345 29.9905 71.743 29.9905H75.2585C76.4521 29.9905 77.038 30.5764 77.038 31.7482V32.855C77.038 33.2239 76.9729 33.5277 76.8644 33.7447C76.7559 33.9617 76.604 34.1353 76.4738 34.2438C76.3001 34.374 76.1048 34.4609 75.9095 34.5043L77.2116 36.8262ZM75.2802 33.7013C75.8444 33.7013 76.1265 33.4192 76.1265 32.855V31.7482C76.1265 31.184 75.8444 30.9019 75.2802 30.9019H72.5676V33.723H75.2802V33.7013Z"
        fill="url(#paint4_linear_619_632)"
      />
      <path
        d="M0.043457 31.6831C0.043457 30.5547 0.62938 29.9688 1.82293 29.9688H4.10151C5.29506 29.9688 5.88098 30.533 5.88098 31.6614V32.052C5.88098 32.1388 5.83758 32.2039 5.72908 32.2039H5.07805C4.96955 32.2039 4.92614 32.1605 4.92614 32.052V31.6831C4.92614 31.1406 4.64403 30.8802 4.07981 30.8802H1.82293C1.2587 30.8802 0.976593 31.1623 0.976593 31.7048V35.2855C0.976593 35.828 1.2587 36.1101 1.82293 36.1101H4.10151C4.66573 36.1101 4.94784 35.828 4.94784 35.2638V34.1353H3.47219C3.36368 34.1353 3.32028 34.0919 3.32028 33.9834V33.3975C3.32028 33.289 3.36368 33.2456 3.47219 33.2456H5.75078C5.85928 33.2456 5.90268 33.289 5.90268 33.3975V35.2638C5.90268 36.4139 5.31676 36.9998 4.12321 36.9998H1.82293C0.62938 36.9998 0.043457 36.4356 0.043457 35.2855V31.6831Z"
        fill="url(#paint5_linear_619_632)"
      />
      <path
        d="M13.6065 36.848C13.6499 36.9565 13.6282 36.9999 13.498 36.9999H12.8253C12.7602 36.9999 12.6951 36.9782 12.6734 36.9565C12.63 36.9348 12.6083 36.8914 12.5866 36.848L11.393 34.6345H8.96253V36.848C8.96253 36.9565 8.91912 36.9999 8.81062 36.9999H8.1596C8.05109 36.9999 8.00769 36.9565 8.00769 36.848V30.1858C8.00769 30.0773 8.05109 30.0339 8.1596 30.0339H11.6751C12.8687 30.0339 13.4546 30.6199 13.4546 31.7917V32.8984C13.4546 33.2674 13.3895 33.5712 13.281 33.7882C13.1725 34.0052 13.0206 34.1788 12.8904 34.2873C12.7168 34.4175 12.5215 34.5043 12.3262 34.5477L13.6065 36.848ZM11.6751 33.7231C12.2394 33.7231 12.5215 33.441 12.5215 32.8767V31.77C12.5215 31.2058 12.2394 30.9237 11.6751 30.9237H8.96253V33.7448H11.6751V33.7231Z"
        fill="url(#paint6_linear_619_632)"
      />
      <path
        d="M20.7678 36.1102C20.8763 36.1102 20.9197 36.1536 20.9197 36.2621V36.848C20.9197 36.9565 20.8763 36.9999 20.7895 36.9999H15.7332C15.6247 36.9999 15.5813 36.9565 15.5813 36.848V30.1858C15.5813 30.0773 15.6247 30.0339 15.7332 30.0339H20.681C20.7895 30.0339 20.8329 30.0773 20.8329 30.1858V30.7718C20.8329 30.8803 20.7895 30.9237 20.7027 30.9237H16.5361V33.0503H19.7913C19.8998 33.0503 19.9432 33.0938 19.9432 33.2023V33.7882C19.9432 33.8967 19.8998 33.9401 19.813 33.9401H16.5361V36.1102H20.7678Z"
        fill="url(#paint7_linear_619_632)"
      />
      <path
        d="M27.9291 36.1102C28.0376 36.1102 28.081 36.1536 28.081 36.2621V36.848C28.081 36.9565 28.0376 36.9999 27.9508 36.9999H22.8945C22.786 36.9999 22.7426 36.9565 22.7426 36.848V30.1858C22.7426 30.0773 22.786 30.0339 22.8945 30.0339H27.8422C27.9508 30.0339 27.9942 30.0773 27.9942 30.1858V30.7718C27.9942 30.8803 27.9508 30.9237 27.864 30.9237H23.6757V33.0503H26.9308C27.0393 33.0503 27.0827 33.0938 27.0827 33.2023V33.7882C27.0827 33.8967 27.0393 33.9401 26.9525 33.9401H23.6757V36.1102H27.9291Z"
        fill="url(#paint8_linear_619_632)"
      />
      <path
        d="M34.4175 36.848L30.8586 31.5096H30.8152V36.848C30.8152 36.9565 30.7718 36.9999 30.6633 36.9999H30.0123C29.9038 36.9999 29.8604 36.9565 29.8604 36.848V30.1858C29.8604 30.0773 29.9038 30.0339 30.0123 30.0339H30.7501C30.8803 30.0339 30.9888 30.0773 31.0539 30.1858L34.6128 35.5676H34.6562V30.1858C34.6562 30.0773 34.6996 30.0339 34.8081 30.0339H35.4592C35.5677 30.0339 35.6111 30.0773 35.6111 30.1858V36.848C35.6111 36.9565 35.5677 36.9999 35.4592 36.9999H34.7213C34.5694 36.9999 34.4826 36.9348 34.4175 36.848Z"
        fill="url(#paint9_linear_619_632)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.1711 15.9284L65.6233 7.57359H65.9922L68.4444 15.9067H63.1711V15.9284ZM69.9852 21.0281L71.3089 25.5853C71.5042 26.1495 71.8731 26.5401 72.6327 26.5401H76.7992C77.255 26.5401 77.5588 26.1712 77.3635 25.5853L69.421 0.954837C69.2256 0.390615 68.8567 0 68.0972 0H63.54C62.7805 0 62.4116 0.368914 62.2163 0.954837L54.2521 25.5853C54.0568 26.1495 54.3389 26.5401 54.8163 26.5401H58.9829C59.7424 26.5401 60.1547 26.1712 60.3066 25.5853L61.6304 21.0281H69.9852ZM39.0398 26.5184C39.7993 26.5184 40.1682 26.1495 40.3635 25.5636L45.2896 11.1759H45.6585V25.5853C45.6585 26.1495 46.0275 26.5401 46.6134 26.5401H50.411C50.9753 26.5401 51.3659 26.1712 51.3659 25.5853V0.954837C51.3659 0.390615 50.997 0 50.411 0H45.116C44.3565 0 43.9876 0.368914 43.7923 0.954837L38.1067 17.2522H37.7377L32.0521 0.954837C31.8568 0.390615 31.4879 0 30.7284 0H25.4334C24.8692 0 24.4785 0.368914 24.4785 0.954837V25.5853C24.4785 26.1495 24.8475 26.5401 25.4334 26.5401H29.231C29.7952 26.5401 30.1859 26.1712 30.1859 25.5853V11.1976H30.5548L35.4809 25.5853C35.6762 26.1495 36.0451 26.5401 36.8046 26.5401H39.0398V26.5184ZM10.9806 5.1214C12.1091 5.1214 12.8686 5.88093 12.8686 7.00937V8.33312C12.8686 9.46156 12.1091 10.2211 10.9806 10.2211H5.68562V5.1214H10.9806ZM5.68562 21.4187V15.1689H12.3261C13.4545 15.1689 14.214 15.9284 14.214 17.0569V19.509C14.214 20.6375 13.4545 21.397 12.3261 21.397H5.68562V21.4187ZM0 25.5853C0 26.1495 0.368914 26.5401 0.954836 26.5401H14.0187C17.99 26.5401 19.8997 24.6521 19.8997 20.6592V17.0569C19.8997 13.0856 16.102 12.5214 16.102 12.5214V12.1308C16.102 12.1308 18.5542 11.5665 18.5542 8.33312V5.88092C18.5542 1.90967 16.6662 0 12.6733 0H0.954836C0.390614 0 0 0.368914 0 0.954837V25.5853Z"
        fill="url(#paint10_linear_619_632)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_619_632"
          x1="51.5395"
          y1="36.9564"
          x2="51.5395"
          y2="29.9905"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#589EC5" />
          <stop offset="1" stopColor="#1181BA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_619_632"
          x1="44.3457"
          y1="36.9564"
          x2="44.3457"
          y2="29.9905"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#589EC5" />
          <stop offset="1" stopColor="#1181BA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_619_632"
          x1="59.7803"
          y1="36.9779"
          x2="59.7803"
          y2="30.012"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#589EC5" />
          <stop offset="1" stopColor="#1181BA" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_619_632"
          x1="67.8585"
          y1="36.9779"
          x2="67.8585"
          y2="30.012"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#589EC5" />
          <stop offset="1" stopColor="#1181BA" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_619_632"
          x1="74.4115"
          y1="36.9781"
          x2="74.4115"
          y2="29.9905"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#589EC5" />
          <stop offset="1" stopColor="#1181BA" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_619_632"
          x1="2.97307"
          y1="36.9998"
          x2="2.97307"
          y2="29.9688"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#589EC5" />
          <stop offset="1" stopColor="#1181BA" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_619_632"
          x1="10.8173"
          y1="36.9999"
          x2="10.8173"
          y2="30.0339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#589EC5" />
          <stop offset="1" stopColor="#1181BA" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_619_632"
          x1="18.2505"
          y1="36.9999"
          x2="18.2505"
          y2="30.0339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#589EC5" />
          <stop offset="1" stopColor="#1181BA" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_619_632"
          x1="25.4118"
          y1="36.9999"
          x2="25.4118"
          y2="30.0339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#589EC5" />
          <stop offset="1" stopColor="#1181BA" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_619_632"
          x1="32.7357"
          y1="36.9999"
          x2="32.7357"
          y2="30.0339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#589EC5" />
          <stop offset="1" stopColor="#1181BA" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_619_632"
          x1="38.7118"
          y1="26.5401"
          x2="38.7118"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#589EC5" />
          <stop offset="1" stopColor="#1181BA" />
        </linearGradient>
      </defs>
    </svg>
  ),

  close: (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.5 1L0.5 13M0.5 1L12.5 13" stroke="white" />
    </svg>
  ),
  close_colored: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.8335 1L0.833496 13M0.833496 1L12.8335 13" stroke="#1894C3" />
    </svg>
  ),
  create: (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.28153 6.31389H6.78153V5.81389V0.5H7.21758V5.81389V6.31389H7.71758H13V6.68611H7.71758H7.21758V7.18611V12.5H6.78153V7.18611V6.68611H6.28153H1V6.31389H6.28153Z"
        stroke="white"
      />
    </svg>
  ),
  creat_colored: (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.61491 6.31389H7.11491V5.81389V0.5H7.55096V5.81389V6.31389H8.05096H13.3334V6.68611H8.05096H7.55096V7.18611V12.5H7.11491V7.18611V6.68611H6.61491H1.33337V6.31389H6.61491Z"
        stroke="#1894C3"
      />
    </svg>
  ),

  online: (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 0.5C2.235 0.5 0 2.735 0 5.5C0 8.265 2.235 10.5 5 10.5C7.765 10.5 10 8.265 10 5.5C10 2.735 7.765 0.5 5 0.5Z"
        fill="#48BA67"
      />
    </svg>
  ),

  offline: (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 0.5C2.235 0.5 0 2.735 0 5.5C0 8.265 2.235 10.5 5 10.5C7.765 10.5 10 8.265 10 5.5C10 2.735 7.765 0.5 5 0.5Z"
        fill="#FF5454"
      />
    </svg>
  ),

  pen_white: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      cursor={"pointer"}
    >
      <path
        d="M5.49988 16.7934V19.5001H8.32595L16.661 11.5172L13.8349 8.81055L5.49988 16.7934Z"
        fill="white"
      />
      <path
        d="M18.8466 8.40008L17.0831 6.71112C16.7892 6.42963 16.3144 6.42963 16.0205 6.71112L14.6414 8.03198L17.4674 10.7386L18.8466 9.41779C19.1405 9.1363 19.1405 8.68158 18.8466 8.40008Z"
        fill="white"
      />
    </svg>
  ),
  pen_grey: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.99991 11.5004V14H4.49956L11.8719 6.6277L9.37222 4.12805L1.99991 11.5004Z"
        fill="#D9D9D9"
      />
      <path
        d="M13.8049 3.75476L12.2451 2.19497C11.9852 1.93501 11.5652 1.93501 11.3053 2.19497L10.0854 3.4148L12.5851 5.91446L13.8049 4.69463C14.0649 4.43466 14.0649 4.01472 13.8049 3.75476Z"
        fill="#D9D9D9"
      />
    </svg>
  ),
  pen_green: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      cursor={"pointer"}
    >
      <path
        d="M5.99991 16.7934V19.5001H8.82598L17.161 11.5172L14.3349 8.81055L5.99991 16.7934Z"
        fill="url(#paint0_linear_179_15635)"
      />
      <path
        d="M19.3466 8.40008L17.5831 6.71112C17.2892 6.42963 16.8144 6.42963 16.5205 6.71112L15.1414 8.03198L17.9674 10.7386L19.3466 9.41779C19.6405 9.1363 19.6405 8.68158 19.3466 8.40008Z"
        fill="url(#paint1_linear_179_15635)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_179_15635"
          x1="11.5805"
          y1="8.81055"
          x2="11.5805"
          y2="19.5001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4ABA69" />
          <stop offset="1" stopColor="#1683BB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_179_15635"
          x1="17.3542"
          y1="6.5"
          x2="17.3542"
          y2="10.7386"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4ABA69" />
          <stop offset="1" stopColor="#1683BB" />
        </linearGradient>
      </defs>
    </svg>
  ),

  broken_line: (
    <svg
      width="399"
      height="20"
      viewBox="0 0 399 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 1H398.015" stroke="#48BA67" strokeDasharray="6 6" />
    </svg>
  ),

  plus_white: (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.28153 6.31389H6.78153V5.81389V0.5H7.21758V5.81389V6.31389H7.71758H13V6.68611H7.71758H7.21758V7.18611V12.5H6.78153V7.18611V6.68611H6.28153H1V6.31389H6.28153Z"
        stroke="white"
      />
    </svg>
  ),
  error: (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
      <path
        d="M5.85 8.45H7.15V9.75H5.85V8.45ZM5.85 3.25H7.15V7.15H5.85V3.25ZM6.4935 0C2.9055 0 0 2.912 0 6.5C0 10.088 2.9055 13 6.4935 13C10.088 13 13 10.088 13 6.5C13 2.912 10.088 0 6.4935 0ZM6.5 11.7C3.627 11.7 1.3 9.373 1.3 6.5C1.3 3.627 3.627 1.3 6.5 1.3C9.373 1.3 11.7 3.627 11.7 6.5C11.7 9.373 9.373 11.7 6.5 11.7Z"
        fill="#FF5454"
      />
    </svg>
  ),
  ok: (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.59 9.49L10.1725 4.9075L9.2625 3.9975L5.59 7.67L3.7375 5.8175L2.8275 6.7275L5.59 9.49ZM6.5 13C5.60083 13 4.75583 12.8293 3.965 12.4878C3.17417 12.1468 2.48625 11.6838 1.90125 11.0988C1.31625 10.5138 0.853233 9.82583 0.5122 9.035C0.170733 8.24417 0 7.39917 0 6.5C0 5.60083 0.170733 4.75583 0.5122 3.965C0.853233 3.17417 1.31625 2.48625 1.90125 1.90125C2.48625 1.31625 3.17417 0.853017 3.965 0.51155C4.75583 0.170517 5.60083 0 6.5 0C7.39917 0 8.24417 0.170517 9.035 0.51155C9.82583 0.853017 10.5138 1.31625 11.0988 1.90125C11.6838 2.48625 12.1468 3.17417 12.4878 3.965C12.8293 4.75583 13 5.60083 13 6.5C13 7.39917 12.8293 8.24417 12.4878 9.035C12.1468 9.82583 11.6838 10.5138 11.0988 11.0988C10.5138 11.6838 9.82583 12.1468 9.035 12.4878C8.24417 12.8293 7.39917 13 6.5 13ZM6.5 11.7C7.95167 11.7 9.18125 11.1962 10.1887 10.1887C11.1962 9.18125 11.7 7.95167 11.7 6.5C11.7 5.04833 11.1962 3.81875 10.1887 2.81125C9.18125 1.80375 7.95167 1.3 6.5 1.3C5.04833 1.3 3.81875 1.80375 2.81125 2.81125C1.80375 3.81875 1.3 5.04833 1.3 6.5C1.3 7.95167 1.80375 9.18125 2.81125 10.1887C3.81875 11.1962 5.04833 11.7 6.5 11.7Z"
        fill="#48BA67"
      />
    </svg>
  ),
  charging: (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.523 0.137386L0.805601 6.16855C0.205296 6.54549 0.542967 7.2409 1.34963 7.29289L8.93785 7.79982L4.38867 12.1932C4.18231 12.3947 4.21045 12.6741 4.46371 12.8496C4.7451 13.0446 5.18595 13.0511 5.47672 12.8626L15.1942 6.83145C15.7945 6.45451 15.4568 5.7591 14.6501 5.70711L7.0619 5.20018L11.6111 0.806793C11.8174 0.605321 11.7893 0.32586 11.536 0.150384C11.2547 -0.0445884 10.8138 -0.0510874 10.523 0.137386Z"
        fill="#48BA67"
      />
    </svg>
  ),
  charged: (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.523 0.137386L0.805601 6.16855C0.205296 6.54549 0.542967 7.2409 1.34963 7.29289L8.93785 7.79982L4.38867 12.1932C4.18231 12.3947 4.21045 12.6741 4.46371 12.8496C4.7451 13.0446 5.18595 13.0511 5.47672 12.8626L15.1942 6.83145C15.7945 6.45451 15.4568 5.7591 14.6501 5.70711L7.0619 5.20018L11.6111 0.806793C11.8174 0.605321 11.7893 0.32586 11.536 0.150384C11.2547 -0.0445884 10.8138 -0.0510874 10.523 0.137386Z"
        fill="#1894C3"
      />
    </svg>
  ),
  charging_st: (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6667 0C19.8312 3.77363e-08 22.9247 0.938384 25.5559 2.69649C28.1871 4.45459 30.2378 6.95345 31.4488 9.87707C32.6598 12.8007 32.9767 16.0177 32.3593 19.1214C31.7419 22.2251 30.2181 25.0761 27.9805 27.3137C25.7428 29.5513 22.8919 31.0752 19.7882 31.6926C16.6845 32.3099 13.4674 31.9931 10.5438 30.7821C7.62019 29.5711 5.12134 27.5203 3.36323 24.8891C1.60513 22.2579 0.666748 19.1645 0.666748 16H3.86675C3.86675 18.5316 4.61745 21.0063 6.02394 23.1113C7.43042 25.2162 9.42951 26.8569 11.7684 27.8257C14.1073 28.7945 16.6809 29.0479 19.1639 28.5541C21.6469 28.0602 23.9276 26.8411 25.7177 25.051C27.5078 23.2609 28.7269 20.9801 29.2208 18.4972C29.7147 16.0142 29.4612 13.4405 28.4924 11.1017C27.5236 8.76276 25.883 6.76367 23.778 5.35719C21.6731 3.95071 19.1983 3.2 16.6667 3.2V0Z"
        fill="url(#paint0_linear_247_7927)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_247_7927"
          x1="16.6667"
          y1="0"
          x2="16.6667"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4ABA69" />
          <stop offset="1" stopColor="#1683BB" />
        </linearGradient>
      </defs>

      <g transform="translate(8, 7)">
        <svg
          width="16"
          height="13"
          viewBox="0 0 16 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.1899 0.137386L0.472471 6.16855C-0.127834 6.54549 0.209838 7.2409 1.0165 7.29289L8.60472 7.79982L4.05554 12.1932C3.84918 12.3947 3.87732 12.6741 4.13058 12.8496C4.41197 13.0446 4.85282 13.0511 5.14359 12.8626L14.861 6.83145C15.4613 6.45451 15.1237 5.7591 14.317 5.70711L6.72877 5.20018L11.278 0.806793C11.4843 0.605321 11.4562 0.32586 11.2029 0.150384C10.9215 -0.0445884 10.4807 -0.0510874 10.1899 0.137386Z"
            fill="#48BA67"
          />
        </svg>
      </g>
    </svg>
  ),
  restart: (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0L1.91064 1.91064C0.732074 3.08634 0 4.70776 0 6.5C0 10.0841 2.9159 13 6.5 13C10.0841 13 13 10.0841 13 6.5C13 2.9159 10.0841 0 6.5 0V1.3C9.36715 1.3 11.7 3.63285 11.7 6.5C11.7 9.36715 9.36715 11.7 6.5 11.7C3.63285 11.7 1.3 9.36715 1.3 6.5C1.3 5.06611 1.88531 3.76823 2.82725 2.82725L4.55 4.55V0L0 0Z"
        fill="white"
      />
    </svg>
  ),
  start: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.50999 9.00004C7.22956 9.00004 7.00922 8.78003 7.00922 8.50003V1.5C7.00922 1.22 7.22956 1 7.50999 1C7.79042 1 8.01076 1.22 8.01076 1.5V8.50003C8.01076 8.78003 7.79042 9.00004 7.50999 9.00004Z"
        fill="white"
      />
      <path
        d="M7.51002 14C3.9245 14 1 11.18 1 7.71997C1 5.30996 2.46225 3.07995 4.72573 2.03995C4.97612 1.92995 5.27658 2.03995 5.38675 2.28995C5.49692 2.53995 5.38675 2.83995 5.13636 2.94995C3.22342 3.81996 1.99153 5.68996 1.99153 7.71997C1.99153 10.63 4.46533 13 7.5 13C10.5347 13 13.0085 10.63 13.0085 7.71997C13.0085 5.69996 11.7766 3.81996 9.86364 2.94995C9.74295 2.89538 9.64884 2.79529 9.60191 2.67159C9.55498 2.54789 9.55906 2.41066 9.61325 2.28995C9.72342 2.03995 10.0239 1.92995 10.2743 2.03995C12.5378 3.06995 14 5.29996 14 7.71997C14 11.18 11.0755 14 7.48998 14H7.51002Z"
        fill="white"
      />
      <path
        d="M7.50999 9.00004C7.22956 9.00004 7.00922 8.78003 7.00922 8.50003V1.5C7.00922 1.22 7.22956 1 7.50999 1C7.79042 1 8.01076 1.22 8.01076 1.5V8.50003C8.01076 8.78003 7.79042 9.00004 7.50999 9.00004Z"
        stroke="white"
        strokeWidth="0.5"
      />
      <path
        d="M7.51002 14C3.9245 14 1 11.18 1 7.71997C1 5.30996 2.46225 3.07995 4.72573 2.03995C4.97612 1.92995 5.27658 2.03995 5.38675 2.28995C5.49692 2.53995 5.38675 2.83995 5.13636 2.94995C3.22342 3.81996 1.99153 5.68996 1.99153 7.71997C1.99153 10.63 4.46533 13 7.5 13C10.5347 13 13.0085 10.63 13.0085 7.71997C13.0085 5.69996 11.7766 3.81996 9.86364 2.94995C9.74295 2.89538 9.64884 2.79529 9.60191 2.67159C9.55498 2.54789 9.55906 2.41066 9.61325 2.28995C9.72342 2.03995 10.0239 1.92995 10.2743 2.03995C12.5378 3.06995 14 5.29996 14 7.71997C14 11.18 11.0755 14 7.48998 14H7.51002Z"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  ),
  organizations: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.82383 3.23684V1.86842C4.82383 1.49211 4.95123 1.16984 5.20603 0.901632C5.46039 0.633877 5.76633 0.5 6.12383 0.5H8.72383C9.08133 0.5 9.38748 0.633877 9.64228 0.901632C9.89664 1.16984 10.0238 1.49211 10.0238 1.86842V3.23684H12.6238C12.9813 3.23684 13.2875 3.37095 13.5423 3.63916C13.7966 3.90691 13.9238 4.22895 13.9238 4.60526V12.1316C13.9238 12.5079 13.7966 12.8302 13.5423 13.0984C13.2875 13.3661 12.9813 13.5 12.6238 13.5H2.22383C1.86633 13.5 1.56039 13.3661 1.30603 13.0984C1.05123 12.8302 0.923828 12.5079 0.923828 12.1316V4.60526C0.923828 4.22895 1.05123 3.90691 1.30603 3.63916C1.56039 3.37095 1.86633 3.23684 2.22383 3.23684H4.82383ZM6.12383 3.23684H8.72383V1.86842H6.12383V3.23684ZM12.6238 9.39474H9.37383V10.7632H5.47383V9.39474H2.22383V12.1316H12.6238V9.39474ZM6.77383 9.39474H8.07383V8.02632H6.77383V9.39474ZM2.22383 8.02632H5.47383V6.6579H9.37383V8.02632H12.6238V4.60526H2.22383V8.02632Z"
        fill="white"
      />
    </svg>
  ),
  plants: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.42371 12.2779V19.5001H8.96916V15.889H10.151V19.5001H13.6964V12.2779L9.56007 8.66675L5.42371 12.2779ZM12.5146 18.0556H11.3328V14.4445H7.78734V18.0556H6.60552V13.0217L9.56007 10.4434L12.5146 13.0217V18.0556Z"
        fill="white"
      />
      <path
        d="M16.0602 9.38892H14.8784V10.8334H16.0602V9.38892Z"
        fill="white"
      />
      <path
        d="M16.0602 12.2778H14.8784V13.7223H16.0602V12.2778Z"
        fill="white"
      />
      <path
        d="M16.0602 15.1667H14.8784V16.6112H16.0602V15.1667Z"
        fill="white"
      />
      <path
        d="M10.7419 6.5V7.92278L11.9237 8.95556V7.94444H17.2419V18.0556H14.8782V19.5H18.4237V6.5H10.7419Z"
        fill="white"
      />
    </svg>
  ),
  modules: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.19871 13.5C2.57037 13.5 2.03412 13.2779 1.58996 12.8338C1.14579 12.3896 0.923706 11.8533 0.923706 11.225C0.923706 10.5967 1.14579 10.0604 1.58996 9.61625C2.03412 9.17208 2.57037 8.95 3.19871 8.95C3.39371 8.95 3.58329 8.97437 3.76746 9.02312C3.95162 9.07187 4.12496 9.13958 4.28746 9.22625L6.77371 6.74V4.9525C6.29704 4.81167 5.90704 4.54354 5.60371 4.14813C5.30037 3.75271 5.14871 3.295 5.14871 2.775C5.14871 2.14667 5.37079 1.61042 5.81496 1.16625C6.25912 0.722083 6.79537 0.5 7.42371 0.5C8.05204 0.5 8.58829 0.722083 9.03246 1.16625C9.47662 1.61042 9.69871 2.14667 9.69871 2.775C9.69871 3.295 9.54704 3.75271 9.24371 4.14813C8.94037 4.54354 8.55037 4.81167 8.07371 4.9525V6.74L10.5762 9.22625C10.7387 9.13958 10.9093 9.07187 11.0881 9.02312C11.2668 8.97437 11.4537 8.95 11.6487 8.95C12.277 8.95 12.8133 9.17208 13.2575 9.61625C13.7016 10.0604 13.9237 10.5967 13.9237 11.225C13.9237 11.8533 13.7016 12.3896 13.2575 12.8338C12.8133 13.2779 12.277 13.5 11.6487 13.5C11.0204 13.5 10.4841 13.2779 10.04 12.8338C9.59579 12.3896 9.37371 11.8533 9.37371 11.225C9.37371 11.03 9.39808 10.8404 9.44683 10.6562C9.49558 10.4721 9.56329 10.2988 9.64996 10.1363L7.42371 7.91L5.19746 10.1363C5.28412 10.2988 5.35183 10.4721 5.40058 10.6562C5.44933 10.8404 5.47371 11.03 5.47371 11.225C5.47371 11.8533 5.25162 12.3896 4.80746 12.8338C4.36329 13.2779 3.82704 13.5 3.19871 13.5ZM11.6487 12.2C11.9195 12.2 12.1497 12.1052 12.3393 11.9156C12.5289 11.726 12.6237 11.4958 12.6237 11.225C12.6237 10.9542 12.5289 10.724 12.3393 10.5344C12.1497 10.3448 11.9195 10.25 11.6487 10.25C11.3779 10.25 11.1477 10.3448 10.9581 10.5344C10.7685 10.724 10.6737 10.9542 10.6737 11.225C10.6737 11.4958 10.7685 11.726 10.9581 11.9156C11.1477 12.1052 11.3779 12.2 11.6487 12.2ZM7.42371 3.75C7.69454 3.75 7.92475 3.65521 8.11433 3.46563C8.30391 3.27604 8.39871 3.04583 8.39871 2.775C8.39871 2.50417 8.30391 2.27396 8.11433 2.08438C7.92475 1.89479 7.69454 1.8 7.42371 1.8C7.15287 1.8 6.92266 1.89479 6.73308 2.08438C6.5435 2.27396 6.44871 2.50417 6.44871 2.775C6.44871 3.04583 6.5435 3.27604 6.73308 3.46563C6.92266 3.65521 7.15287 3.75 7.42371 3.75ZM3.19871 12.2C3.46954 12.2 3.69975 12.1052 3.88933 11.9156C4.07891 11.726 4.17371 11.4958 4.17371 11.225C4.17371 10.9542 4.07891 10.724 3.88933 10.5344C3.69975 10.3448 3.46954 10.25 3.19871 10.25C2.92787 10.25 2.69766 10.3448 2.50808 10.5344C2.3185 10.724 2.22371 10.9542 2.22371 11.225C2.22371 11.4958 2.3185 11.726 2.50808 11.9156C2.69766 12.1052 2.92787 12.2 3.19871 12.2Z"
        fill="white"
      />
    </svg>
  ),
  stations: (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9468 0.637386L1.22937 6.66855C0.629063 7.04549 0.966735 7.7409 1.77339 7.79289L9.36162 8.29982L4.81244 12.6932C4.60608 12.8947 4.63422 13.1741 4.88747 13.3496C5.16887 13.5446 5.60972 13.5511 5.90049 13.3626L15.6179 7.33145C16.2182 6.95451 15.8806 6.2591 15.0739 6.20711L7.48567 5.70018L12.0349 1.30679C12.2412 1.10532 12.2131 0.82586 11.9598 0.650384C11.6784 0.455412 11.2376 0.448913 10.9468 0.637386Z"
        fill="white"
      />
    </svg>
  ),
  users: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.18074 5.66675C7.18074 4.56675 6.28074 3.66675 5.18074 3.66675C4.08074 3.66675 3.18074 4.56675 3.18074 5.66675C3.18074 6.76675 4.08074 7.66675 5.18074 7.66675C6.28074 7.66675 7.18074 6.76675 7.18074 5.66675ZM5.18074 6.33342C4.81407 6.33342 4.51407 6.03342 4.51407 5.66675C4.51407 5.30009 4.81407 5.00009 5.18074 5.00009C5.54741 5.00009 5.84741 5.30009 5.84741 5.66675C5.84741 6.03342 5.54741 6.33342 5.18074 6.33342ZM9.51407 7.66675C10.2541 7.66675 10.8474 7.07342 10.8474 6.33342C10.8474 5.59342 10.2541 5.00009 9.51407 5.00009C8.77407 5.00009 8.17407 5.59342 8.18074 6.33342C8.18074 7.07342 8.77407 7.66675 9.51407 7.66675ZM6.84074 0.340088C3.16074 0.340088 0.174072 3.32675 0.174072 7.00675C0.174072 10.6868 3.16074 13.6734 6.84074 13.6734C10.5207 13.6734 13.5074 10.6868 13.5074 7.00675C13.5074 3.32675 10.5207 0.340088 6.84074 0.340088ZM2.74074 10.4134C3.19407 10.0534 4.25407 9.67342 5.18074 9.67342C5.22741 9.67342 5.28074 9.68009 5.33407 9.68009C5.49407 9.25342 5.78074 8.82009 6.20074 8.44009C5.82741 8.37342 5.47407 8.33342 5.18074 8.33342C4.31407 8.33342 2.92074 8.63342 2.02741 9.28675C1.69407 8.59342 1.50741 7.82009 1.50741 7.00009C1.50741 4.06009 3.90074 1.66675 6.84074 1.66675C9.78074 1.66675 12.1741 4.06009 12.1741 7.00009C12.1741 7.80009 11.9941 8.56009 11.6741 9.24675C11.0074 8.85342 10.1007 8.66675 9.51407 8.66675C8.50074 8.66675 6.51407 9.20675 6.51407 10.4668V12.3201C5.00074 12.2334 3.65407 11.5134 2.74074 10.4134Z"
        fill="white"
      />
    </svg>
  ),
  adminIcon: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 32 32"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18,29H14a1,1,0,0,1-1-1V26.56a1.38,1.38,0,0,0-2.35-1l-1,1a1,1,0,0,1-1.42,0L5.39,23.78a1,1,0,0,1,0-1.42l1-1a1.38,1.38,0,0,0-1-2.35H4a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H5.44a1.38,1.38,0,0,0,1-2.35l-1-1a1,1,0,0,1,0-1.42L8.22,5.39a1,1,0,0,1,1.42,0l1,1a1.38,1.38,0,0,0,2.35-1V4a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1V5.44a1.38,1.38,0,0,0,2.35,1l1-1a1,1,0,0,1,1.42,0l2.83,2.83a1,1,0,0,1,0,1.42l-1,1a1.38,1.38,0,0,0,1,2.35H28a1,1,0,0,1,1,1v4a1,1,0,0,1-1,1H26.56a1.38,1.38,0,0,0-1,2.35l1,1a1,1,0,0,1,0,1.42l-2.83,2.83a1,1,0,0,1-1.42,0l-1-1a1.38,1.38,0,0,0-2.35,1V28A1,1,0,0,1,18,29Zm-3-2h2v-.44a3.37,3.37,0,0,1,5.76-2.38l.31.31,1.42-1.42-.31-.31A3.37,3.37,0,0,1,26.56,17H27V15h-.44a3.37,3.37,0,0,1-2.38-5.76l.31-.31L23.07,7.51l-.31.31A3.37,3.37,0,0,1,17,5.44V5H15v.44A3.37,3.37,0,0,1,9.24,7.82l-.31-.31L7.51,8.93l.31.31A3.37,3.37,0,0,1,5.44,15H5v2h.44a3.37,3.37,0,0,1,2.38,5.76l-.31.31,1.42,1.42.31-.31A3.37,3.37,0,0,1,15,26.56Z" />
      <path d="M16,21a5,5,0,1,1,5-5A5,5,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,16,13Z" />
    </svg>
  ),
  dog: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0.300003C3.32 0.300003 0.333334 3.28667 0.333334 6.96667C0.333334 10.6467 3.32 13.6333 7 13.6333H10.3333V12.3H7C4.10667 12.3 1.66667 9.86 1.66667 6.96667C1.66667 4.07334 4.10667 1.63334 7 1.63334C9.89333 1.63334 12.3333 4.07334 12.3333 6.96667V7.92C12.3333 8.44667 11.86 8.96667 11.3333 8.96667C10.8067 8.96667 10.3333 8.44667 10.3333 7.92V6.96667C10.3333 5.12667 8.84 3.63334 7 3.63334C5.16 3.63334 3.66667 5.12667 3.66667 6.96667C3.66667 8.80667 5.16 10.3 7 10.3C7.92 10.3 8.76 9.92667 9.36 9.32C9.79333 9.91334 10.54 10.3 11.3333 10.3C12.6467 10.3 13.6667 9.23334 13.6667 7.92V6.96667C13.6667 3.28667 10.68 0.300003 7 0.300003ZM7 8.96667C5.89333 8.96667 5 8.07334 5 6.96667C5 5.86 5.89333 4.96667 7 4.96667C8.10667 4.96667 9 5.86 9 6.96667C9 8.07334 8.10667 8.96667 7 8.96667Z"
        fill="url(#paint0_linear_195_2771)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_195_2771"
          x1="7"
          y1="0.300003"
          x2="7"
          y2="13.6333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4ABA69" />
          <stop offset="1" stopColor="#1683BB" />
        </linearGradient>
      </defs>
    </svg>
  ),
  phone: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.64 1.33333C9.6 1.92667 9.5 2.50667 9.34 3.06L10.14 3.86C10.4133 3.06 10.5867 2.21333 10.6467 1.33333H9.64ZM3.06667 9.34667C2.5 9.50667 1.92 9.60667 1.33333 9.64667V10.64C2.21333 10.58 3.06 10.4067 3.86667 10.14L3.06667 9.34667ZM9 0H11.3333C11.7 0 12 0.3 12 0.666667C12 6.92667 6.92667 12 0.666667 12C0.3 12 0 11.7 0 11.3333V9.00667C0 8.64 0.3 8.34 0.666667 8.34C1.49333 8.34 2.3 8.20667 3.04667 7.96C3.11333 7.93333 3.18667 7.92667 3.25333 7.92667C3.42667 7.92667 3.59333 7.99333 3.72667 8.12L5.19333 9.58667C7.08 8.62 8.62667 7.08 9.58667 5.19333L8.12 3.72667C7.93333 3.54 7.88 3.28 7.95333 3.04667C8.2 2.3 8.33333 1.5 8.33333 0.666667C8.33333 0.3 8.63333 0 9 0Z"
        fill="url(#paint0_linear_195_2758)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_195_2758"
          x1="6"
          y1="0"
          x2="6"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4ABA69" />
          <stop offset="1" stopColor="#1683BB" />
        </linearGradient>
      </defs>
    </svg>
  ),
  add_img: (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 4.00001H11.8867L10.6667 2.66667H6.66667V4.00001H10.08L11.3 5.33334H14V13.3333H3.33333V7.33334H2V13.3333C2 14.0667 2.6 14.6667 3.33333 14.6667H14C14.7333 14.6667 15.3333 14.0667 15.3333 13.3333V5.33334C15.3333 4.60001 14.7333 4.00001 14 4.00001ZM5.33333 9.33334C5.33333 11.1733 6.82667 12.6667 8.66667 12.6667C10.5067 12.6667 12 11.1733 12 9.33334C12 7.49334 10.5067 6.00001 8.66667 6.00001C6.82667 6.00001 5.33333 7.49334 5.33333 9.33334ZM8.66667 7.33334C9.76667 7.33334 10.6667 8.23334 10.6667 9.33334C10.6667 10.4333 9.76667 11.3333 8.66667 11.3333C7.56667 11.3333 6.66667 10.4333 6.66667 9.33334C6.66667 8.23334 7.56667 7.33334 8.66667 7.33334ZM3.33333 4.00001H5.33333V2.66667H3.33333V0.666672H2V2.66667H0V4.00001H2V6.00001H3.33333V4.00001Z"
        fill="url(#paint0_linear_244_2584)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_244_2584"
          x1="7.66667"
          y1="0.666672"
          x2="7.66667"
          y2="14.6667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4ABA69" />
          <stop offset="1" stopColor="#1683BB" />
        </linearGradient>
      </defs>
    </svg>
  ),
  arrow: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      cursor={"pointer"}
    >
      <path
        d="M9.02593 6.86133V8.24594H14.9728L8.33362 14.8852L9.30977 15.8613L15.949 9.2221V15.169H17.3336V6.86133H9.02593Z"
        fill="url(#paint0_linear_249_7048)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_249_7048"
          x1="12.8336"
          y1="6.86133"
          x2="12.8336"
          y2="15.8613"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4ABA69" />
          <stop offset="1" stopColor="#1683BB" />
        </linearGradient>
      </defs>
    </svg>
  ),
  min: (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.19255 0.861328V2.24594H7.13948L0.500244 8.88517L1.4764 9.86133L8.11563 3.2221V9.16902H9.50024V0.861328H1.19255Z"
        fill="white"
      />
    </svg>
  ),
  minimize: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 7H12"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  station_preparing: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 33 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Только фоновый круг с градиентом */}
      <path
        d="M32.125 16C32.125 24.8366 24.9616 32 16.125 32C7.28844 32 0.125 24.8366 0.125 16C0.125 7.16344 7.28844 0 16.125 0C24.9616 0 32.125 7.16344 32.125 16ZM3.325 16C3.325 23.0692 9.05575 28.8 16.125 28.8C23.1942 28.8 28.925 23.0692 28.925 16C28.925 8.93075 23.1942 3.2 16.125 3.2C9.05575 3.2 3.325 8.93075 3.325 16Z"
        fill="url(#paint0_linear_247_8079)"
      />
      {/* Нет внутренней иконки — пусто */}
      <defs>
        <linearGradient
          id="paint0_linear_247_8079"
          x1="16.125"
          y1="32"
          x2="16.125"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#589EC5" />
          <stop offset="1" stopColor="#1181BA" />
        </linearGradient>
      </defs>
    </svg>
  ),

  station_ready: (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.125 16C32.125 24.8366 24.9616 32 16.125 32C7.28844 32 0.125 24.8366 0.125 16C0.125 7.16344 7.28844 0 16.125 0C24.9616 0 32.125 7.16344 32.125 16ZM3.325 16C3.325 23.0692 9.05575 28.8 16.125 28.8C23.1942 28.8 28.925 23.0692 28.925 16C28.925 8.93075 23.1942 3.2 16.125 3.2C9.05575 3.2 3.325 8.93075 3.325 16Z"
        fill="url(#paint0_linear_247_8079)"
      />
      <path
        d="M14.6116 21.52L23.0716 13.06L21.3916 11.38L14.6116 18.16L11.1916 14.74L9.51163 16.42L14.6116 21.52Z"
        fill="var(--logo)"
      />

      <defs>
        <linearGradient
          id="paint0_linear_247_8079"
          x1="16.125"
          y1="32"
          x2="16.125"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#589EC5" />
          <stop offset="1" stopColor="#1181BA" />
        </linearGradient>
      </defs>
    </svg>
  ),
  station_err: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 33 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.8335"
        y="1"
        width="30"
        height="30"
        rx="15"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M16.0085 19.6H18.4085V22H16.0085V19.6ZM16.0085 10H18.4085V17.2H16.0085V10ZM17.1965 4C10.5725 4 5.2085 9.376 5.2085 16C5.2085 22.624 10.5725 28 17.1965 28C23.8325 28 29.2085 22.624 29.2085 16C29.2085 9.376 23.8325 4 17.1965 4ZM17.2085 25.6C11.9045 25.6 7.6085 21.304 7.6085 16C7.6085 10.696 11.9045 6.4 17.2085 6.4C22.5125 6.4 26.8085 10.696 26.8085 16C26.8085 21.304 22.5125 25.6 17.2085 25.6Z"
        fill="currentColor"
      />
    </svg>
  ),

  station_unavailable: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 33 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.8335"
        y="1"
        width="30"
        height="30"
        rx="15"
        stroke="currentColor"
        strokeWidth="2"
        fill="currentColor"
      />
      {/* Нет внутреннего символа — просто пустой круг */}
    </svg>
  ),
  station_free: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 33 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Фоновый круг с серой обводкой */}
      <rect
        x="1.16663"
        y="1"
        width="30"
        height="30"
        rx="15"
        stroke="currentColor"
        strokeWidth="2"
        fill="none" /* можно оставить прозрачным */
      />
      {/* Галочка сверху */}
      <path
        d="M14.6116 21.52L23.0716 13.06L21.3916 11.38L14.6116 18.16L11.1916 14.74L9.51163 16.42L14.6116 21.52ZM16.2916 28C14.6316 28 13.0716 27.6848 11.6116 27.0544C10.1516 26.4248 8.88163 25.57 7.80163 24.49C6.72163 23.41 5.86683 22.14 5.23723 20.68C4.60683 19.22 4.29163 17.66 4.29163 16C4.29163 14.34 4.60683 12.78 5.23723 11.32C5.86683 9.86 6.72163 8.59 7.80163 7.51C8.88163 6.43 10.1516 5.5748 11.6116 4.9444C13.0716 4.3148 14.6316 4 16.2916 4C17.9516 4 19.5116 4.3148 20.9716 4.9444C22.4316 5.5748 23.7016 6.43 24.7816 7.51C25.8616 8.59 26.7164 9.86 27.346 11.32C27.9764 12.78 28.2916 14.34 28.2916 16C28.2916 17.66 27.9764 19.22 27.346 20.68C26.7164 22.14 25.8616 23.41 24.7816 24.49C23.7016 25.57 22.4316 26.4248 20.9716 27.0544C19.5116 27.6848 17.9516 28 16.2916 28ZM16.2916 25.6C18.9716 25.6 21.2416 24.67 23.1016 22.81C24.9616 20.95 25.8916 18.68 25.8916 16C25.8916 13.32 24.9616 11.05 23.1016 9.19C21.2416 7.33 18.9716 6.4 16.2916 6.4C13.6116 6.4 11.3416 7.33 9.48163 9.19C7.62163 11.05 6.69163 13.32 6.69163 16C6.69163 18.68 7.62163 20.95 9.48163 22.81C11.3416 24.67 13.6116 25.6 16.2916 25.6Z"
        fill="currentColor"
      />
    </svg>
  ),
  station_charge: (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6667 0C19.8312 3.77363e-08 22.9247 0.938384 25.5559 2.69649C28.1871 4.45459 30.2378 6.95345 31.4488 9.87707C32.6598 12.8007 32.9767 16.0177 32.3593 19.1214C31.7419 22.2251 30.2181 25.0761 27.9805 27.3137C25.7428 29.5513 22.8919 31.0752 19.7882 31.6926C16.6845 32.3099 13.4674 31.9931 10.5438 30.7821C7.6202 29.5711 5.12134 27.5203 3.36323 24.8891C1.60513 22.2579 0.666748 19.1645 0.666748 16L3.86675 16C3.86675 18.5316 4.61745 21.0063 6.02394 23.1113C7.43042 25.2162 9.42951 26.8569 11.7684 27.8257C14.1073 28.7945 16.6809 29.0479 19.1639 28.5541C21.6469 28.0602 23.9276 26.8411 25.7177 25.051C27.5078 23.2609 28.7269 20.9801 29.2208 18.4972C29.7147 16.0142 29.4612 13.4405 28.4924 11.1017C27.5236 8.76276 25.883 6.76367 23.778 5.35719C21.6731 3.95071 19.1983 3.2 16.6667 3.2L16.6667 0Z"
        fill="url(#paint0_linear_247_7927)"
      />
      <path
        d="M14.6116 21.52L23.0716 13.06L21.3916 11.38L14.6116 18.16L11.1916 14.74L9.51163 16.42L14.6116 21.52Z"
        fill="var(--logo)"
      />

      <defs>
        <linearGradient
          id="paint0_linear_247_7927"
          x1="16.6667"
          y1="0"
          x2="16.6667"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4ABA69" />
          <stop offset="1" stopColor="#1683BB" />
        </linearGradient>
      </defs>
    </svg>
  ),
  station_noStatus: (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.8335"
        y="1"
        width="30"
        height="30"
        rx="15"
        stroke="grey"
        strokeOpacity="0.34"
        strokeWidth="2"
        fill="none"
      />

      <path
        d="M17.1965 4C10.5725 4 5.2085 9.376 5.2085 16C5.2085 22.624 10.5725 28 17.1965 28C23.8325 28 29.2085 22.624 29.2085 16C29.2085 9.376 23.8325 4 17.1965 4Z"
        stroke="grey"
        fill="none"
      />
    </svg>
  ),
  green_dot: (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_170_1602)">
        <path
          d="M6 2C3.235 2 1 4.235 1 7C1 9.765 3.235 12 6 12C8.765 12 11 9.765 11 7C11 4.235 8.765 2 6 2Z"
          fill="#48BA67"
        />
      </g>
      <defs>
        <clipPath id="clip0_170_1602">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  red_dot: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_170_1619)">
        <path
          d="M6 1.5C3.235 1.5 1 3.735 1 6.5C1 9.265 3.235 11.5 6 11.5C8.765 11.5 11 9.265 11 6.5C11 3.735 8.765 1.5 6 1.5Z"
          fill="#FF5454"
        />
      </g>
      <defs>
        <clipPath id="clip0_170_1619">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  line: (
    <svg
      width="399"
      height="2"
      viewBox="0 0 399 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 1H398.015" stroke="#48BA67" strokeDasharray="6 6" />
    </svg>
  ),
  mark: (
    <svg
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.175 0L5 3.81667L8.825 0L10 1.175L5 6.175L0 1.175L1.175 0Z"
        fill="white"
      />
    </svg>
  ),
  defaultAva: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="60" r="50" fill="#4bc9d7" />
      <circle cx="50" cy="50" r="20" fill="white" />
      <circle cx="50" cy="90" r="30" fill="white" />
    </svg>
  ),
  defaultAvaCircle: (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="50" fill="#4bc9d7" />
      <circle cx="50" cy="36" r="15" fill="white" />
      <circle cx="50" cy="80" r="22" fill="white" />
    </svg>
  ),
  chart: (
    <svg
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
    >
      <path
        fill="#00bcd4"
        d="M5.33333335 6.33333334h3.3333333v6.6666666h-3.3333333zm-4.33333329-3.3333333h3.3333333v9.9999999h-3.3333333zm8.66666658-1.99999998h3.3333333v11.99999988h-3.3333333z"
      />
    </svg>
  ),

  /* `СТ.2` (`oq-ММБ-298`, `ТЕСТ-Н111`): девять контурных иконок состояний
     карточки станции. Формы — по доске «Предложение (редакция 3)». Прежние
     `station_*` не тронуты: их ещё зовут окно станции и другие экраны. */
  st_check: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M8 12.4l2.6 2.6L16.2 9.4" />
    </svg>
  ),
  st_clock: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3.5 2" />
    </svg>
  ),
  st_pause: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 8.5v7M14.5 8.5v7" />
    </svg>
  ),
  st_bolt: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13 3L6.5 13.5H11l-1 7.5L17.5 10.5H13z" />
    </svg>
  ),
  st_alert: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.5v6" />
      <circle cx="12" cy="16.6" r="1.1" fill="currentColor" stroke="none" />
    </svg>
  ),
  st_minus: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M7.5 12h9" />
    </svg>
  ),
  st_gear: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.5v5" />
      <circle cx="12" cy="16.6" r="1.1" fill="currentColor" stroke="none" />
    </svg>
  ),
  st_ring: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" />
    </svg>
  ),
  st_plug: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M6.2 17.8L17.8 6.2" />
      <path d="M9 8.5v3M15 12.5v3" />
    </svg>
  ),
};

export default SVG;
